<div class="intro-container text-center md:text-left mb-10">
    <div class="intro-text-container">
        <img src="../../../../assets/aisslo-white.webp" class="w-[500px] mb-5 " alt="Logo">
        <h1 class="text-3xl font-bold text-center leading-tight text-gray-900 dark:text-white max-md:text-2xl max-md:leading-snug max-md:text-center" style="opacity: 1; transform: none;">Trust operations <span class="bg-gradient-to-r from-blue-600 via-blue-500 to-blue-700 dark:from-blue-400 dark:via-blue-300 dark:to-blue-500 bg-clip-text text-transparent">Intelligence</span></h1>
        <!-- <div class="intro-text text-white text-sm text-center font-inter">
            <p class="text-lg">Secure in a snap</p>
           
        </div> -->
    </div>

  <!-- Buttons -->
  <div
    class="intro-button-container flex flex-row justify-center font-inter font-semibold text-white text-lg mt-12"
  >
    <button
      class="relative text-base h-12 w-44 mr-12 bg-[#31a1f6] text-white font-poppins overflow-hidden hover:text-blue-500 transition-colors duration-300 group"
      (click)="explore()"
    >
      <span
        class="absolute top-0 left-0 h-full w-0 bg-white transition-all duration-300 group-hover:w-full z-0"
      ></span>
      <span class="relative z-10">Learn More</span>
    </button>

    <!-- <a
      class="relative w-44 text-white text-center cursor-pointer before:content-[''] before:absolute before:left-0 before:bottom-0 before:w-0 before:h-[2px] before:bg-blue-500 hover:before:w-full before:transition-all before:duration-300"
    >
      Learn More
    </a> -->
  </div>
</div>
